import { subscribe } from "../api/klaviyo";

class KlaviyoForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.emailContainer = this.querySelector(".input__primary");
    this.emailInput = this.querySelector('input[name="email"]');
    this.inputWrapper = this.querySelector(".js-email-input-wrapper");
    this.successWrapper = this.querySelector(".js-email-success");
    this.errorWrapper = this.querySelector(".js-email-error");
    this.submit = this.querySelector('button[type="submit"]');
    this.form.addEventListener("submit", this.onSubmit);
  }

  destroy = () => {
    this.form.removeEventListener("submit", this.onSubmit);
  };

  onSubmit = (event) => {
    event.preventDefault();

    subscribe(KLAVIYO_LIST_ID, this.emailInput.value)
      .then((response) => {
        if (!response.success) {
          // throw new Error(response.errors[0])
          console.error(response);
          //  this.emailContainer.classList.add("opacity-50");
          // this.submit.classList.remove('cursor-pointer')

          this.errorWrapper.classList.remove("hidden");
          this.errorWrapper.innerHTML = response.errors[0];
          this.emailContainer.classList.add("error");
          setTimeout(() => {
            this.errorWrapper.classList.add("hidden");

            this.emailContainer.classList.remove("error");
          }, 3000);
          return;
        }
        this.errorWrapper.classList.remove("error");
        this.errorWrapper.classList.add("hidden");
        this.submit.style.display = "none";
        // this.emailInput.classList.add('hidden')
        this.emailInput.value = "You're signed up!";
        this.emailInput.disabled = true;
        this.emailInput.style.pointerEvents = "none";
        this.submit.disabled = true;

        // this.successWrapper.classList.remove('hidden')
      })
      .catch((error) => {
        console.error(error);
        this.errorWrapper.classList.remove("hidden");
        this.errorWrapper.innerHTML = response.errors[0];
        this.emailContainer.classList.add("error");
        setTimeout(() => {
          this.errorWrapper.classList.add("hidden");
          this.emailContainer.classList.remove("error");
        }, 3000);
      });
  };
}

if (!customElements.get("klaviyo-form"))
  customElements.define("klaviyo-form", KlaviyoForm);
